import React, { useState } from 'react';
import { Image } from 'semantic-ui-react';
import { Spinner } from 'react-bootstrap';

import { Card, Button } from 'react-bootstrap';
import axios from 'axios';
import url from '../url';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
const SendLink = () => {
    const { t, i18n } = useTranslation()
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const [spin, setSpin] = useState('false')
    const [success, setSuccess] = useState('')
    
    const sendemail = () => {
        setError('')
        setSuccess('')
        if (email == '') {
            setError(t('responses.fields_required'))
            return;
        }

        setSpin('grow')
            var token=sessionStorage.getItem('mytoken', false)
                const config = {
            headers: { Authorization: `Bearer ${token}` }
                };
        var postData = {
      email: email,
      
        };
        
        axios.post(url + 'auth/reset',{email})
            .then(res => {
                // console.log(res)
                setSuccess(res.data.message)
            
            }).catch(e => {
                setError('We didn\'t find your email in the system Kindly create an account')
                // console.log(e)
            
            }).then(r => {
                setSpin('false')
            
        })
        
    }
    return (<div className="container" style={{ height: '100vh' }}>
       
            
        <div className="row">
            
            <div className="col-sm-3"></div>
            <div className="col-sm-6">

                <Card style={{backgroundImage: `url("https://app-test.docsun.health/img/bg.9cd18d37.jpg")`, color:'white'}}>
                    <Card.Header ><div className="row">
                        <div className="col-sm-7">
                            <Image size='small' src='/asse' /> 
                            
                        </div>
                        <div className="col-sm-4">
                            <span className="float-right">{t('password_reset.title') }</span>

                        </div>
                    </div></Card.Header>
                    <Card.Body>
                        <div className="row">
                        <div className="col-sm-12">
                        <Spinner animation={spin} variant="primary" />
                        {error ? <>
                            <div className="alert alert-danger">
                            {error}
                            </div>
                        </> : <></>}
                        {success ? <>
                            <div className="alert alert-info">
                            {success}
                            </div>
                        </> : <></>}
                        
                        </div>
                    </div>
                    
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label>{t('password_reset.email') }</label>
                                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                        className="form-control" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <Button variant="primary" onClick={sendemail }>{t('password_reset.btn_reset') }</Button>
                            </div>
                            <div className="col-sm-4">
                                
                            </div>
                            <div className="col-sm-4">
                                <Button variant="success" as={Link} to="/signin">{t('password_reset.btn_login') }</Button>
                            </div>
                        </div>
                </Card.Body>
                </Card>

            </div>
            <div className="col-sm-3"></div>
        </div>
    </div>    );
}
 
export default SendLink;